import * as React from "react";
const DocumentsView = React.lazy(() => import("./DocumentsViewContainer"));

export { DocumentsView };
